/* Presentation only: colour and stage selection do not affect purchase state. */
if (!customElements.get('jupityr-results-timeline')) {
  customElements.define('jupityr-results-timeline', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.buttons = [...this.querySelectorAll('[data-timeline-trigger]')];
      this.stages = [...this.querySelectorAll('[data-timeline-stage]')];
      this.media = [...this.querySelectorAll('[data-timeline-media]')];
      this.modes = [...this.querySelectorAll('[data-timeline-mode]')];
      this.outcomes = [...this.querySelectorAll('[data-timeline-outcome]')];
      const selectTarget = event => {
        const stage = event.target.closest('[data-timeline-stage]');
        if (stage && this.contains(stage) && !stage.hidden) this.select(stage.dataset.timelineStage);
      };
      this.addEventListener('change', event => {
        if (this.modes.includes(event.target)) this.selectMode(event.target.value);
      }, options);
      this.addEventListener('pointerover', event => {
        if (event.pointerType !== 'touch') selectTarget(event);
      }, options);
      this.addEventListener('focusin', selectTarget, options);
      this.addEventListener('click', selectTarget, options);
      this.addEventListener('keydown', event => {
        const visible = this.buttons.filter(button => !button.closest('[data-timeline-stage]').hidden);
        const index = visible.indexOf(event.target);
        if (index < 0 || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? visible.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + visible.length) % visible.length;
        visible[next].focus();
      }, options);
      document.addEventListener('shopify:block:select', event => {
        const stage = this.stages.find(stage => stage.dataset.timelineStage === event.detail.blockId);
        if (!stage) return;
        if (this.modes.length) this.selectMode(stage.dataset.stageMode);
        this.select(event.detail.blockId);
      }, options);
      if (this.modes.length) this.selectMode(this.modes.find(mode => mode.checked)?.value || 'red');
    }
    selectMode(mode) {
      this.dataset.mode = mode;
      this.modes.forEach(input => { input.checked = input.value === mode; });
      this.outcomes.forEach(outcome => { outcome.hidden = outcome.dataset.timelineOutcome !== mode; });
      this.stages.forEach(stage => { stage.hidden = stage.dataset.stageMode !== mode; });
      const first = this.stages.find(stage => !stage.hidden);
      if (first) this.select(first.dataset.timelineStage);
      else this.media.forEach(media => { media.hidden = true; });
    }
    select(id) {
      this.buttons.forEach(button => button.setAttribute('aria-expanded', String(button.dataset.timelineTrigger === id)));
      this.stages.forEach(stage => {
        const active = stage.dataset.timelineStage === id;
        stage.classList.toggle('is-active', active);
        stage.querySelector('.jupityr-timeline__copy').hidden = !active;
      });
      this.media.forEach(media => { media.hidden = media.dataset.timelineMedia !== id; });
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
